import { twMerge } from "tailwind-merge";
import { TimezoneOption } from "@platform/features/timezones/timezones.types";
import {
  ContiguousTimeslot,
  Timeslot,
} from "@platform/features/timeslots/timeslots.types";
import { SchedulingAvailabilityGrid } from "../SchedulingAvailabilityGrid/SchedulingAvailabilityGrid";
import { SchedulingInstructions } from "../SchedulingInstructions/SchedulingInstructions";
import { SchedulingRequirements } from "../SchedulingRequirements/SchedulingRequirements";
import { SchedulingTimezones } from "../SchedulingTimezones/SchedulingTimezones";

export type Props = {
  isLoading: boolean;
  isSubmitting: boolean;
  timeSlots: Timeslot[];
  selectedTimeSlots: Timeslot[];
  contiguousTimeslots: ContiguousTimeslot[];
  handleMouseDown: (e: React.MouseEvent, slot: Timeslot) => void;
  handleMouseOver: (e: React.MouseEvent, slot: Timeslot) => void;
  handleTouchStart: (e: React.TouchEvent, slot: Timeslot) => void;
  handleTouchEnd: (e: React.TouchEvent, slot: Timeslot) => void;
  handleTouchMove: (e: React.TouchEvent, slot: Timeslot) => void;
  validHoursCount: number;
  timeZoneOptions: TimezoneOption[];
  selectedTimezone: TimezoneOption;
  onTimezoneChange: (val: TimezoneOption | null) => void;
};

export function Scheduling({
  isLoading,
  isSubmitting,
  timeSlots,
  selectedTimeSlots,
  contiguousTimeslots,
  handleMouseDown,
  handleMouseOver,
  handleTouchStart,
  handleTouchMove,
  handleTouchEnd,
  validHoursCount,
  timeZoneOptions,
  selectedTimezone,
  onTimezoneChange,
}: Props) {
  return (
    <div
      className={twMerge(
        "flex flex-col gap-4 md:flex-row",
        isSubmitting && "opacity-20 pointer-events-none"
      )}
    >
      <SchedulingAvailabilityGrid
        className="flex-1"
        isLoading={isLoading}
        timeSlots={timeSlots}
        selectedTimeSlots={selectedTimeSlots}
        contiguousTimeslots={contiguousTimeslots}
        handleMouseDown={handleMouseDown}
        handleMouseOver={handleMouseOver}
        handleTouchStart={handleTouchStart}
        handleTouchMove={handleTouchMove}
        handleTouchEnd={handleTouchEnd}
      />
      <div className="flex flex-col gap-4 w-full flex-1 md:flex-none md:max-w-xs md:min-w-xs">
        <SchedulingTimezones
          options={timeZoneOptions}
          value={selectedTimezone.value}
          onChange={onTimezoneChange}
        />
        <SchedulingInstructions />
        <SchedulingRequirements validHoursCount={validHoursCount} />
      </div>
    </div>
  );
}

export default Scheduling;
